import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f8f2877"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "table w-100" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "text-center mt-5" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: 'Edit ' + _ctx.macroCat.categoryTitle + ' certifications',
          text: 'Edit ' + _ctx.macroCat.categoryTitle + ' certifications'
        }, null, 8, ["localizedKey", "text"])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localMacroCat.subCategories, (subCat, index) => {
              return (_openBlock(), _createElementBlock("td", {
                key: index,
                class: "text-center"
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: subCat.key,
                  text: subCat.key,
                  type: "strong"
                }, null, 8, ["localizedKey", "text"])
              ]))
            }), 128)),
            _hoisted_9
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localMacroCat.subCategories, (subCat, index) => {
              return (_openBlock(), _createElementBlock("td", {
                key: index,
                class: "text-center"
              }, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.localMacroCat.subCategories[index].value), 1)
              ]))
            }), 128)),
            _hoisted_11
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localMacroCat.certifications, (cert, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.localMacroCat.certifications[index].title) = $event)
                }, null, 8, _hoisted_12), [
                  [_vModelText, _ctx.localMacroCat.certifications[index].title]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localMacroCat.subCategories, (subCat, subCatIndx) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: subCatIndx,
                  class: "text-center"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((cert.subCategories.filter(x => x.key == subCat.key)[0].value) = $event)
                  }, null, 8, _hoisted_13), [
                    [_vModelText, cert.subCategories.filter(x => x.key == subCat.key)[0].value]
                  ])
                ]))
              }), 128)),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "btn btn-primary w-100 justify-content-center",
                  onClick: ($event: any) => (_ctx.removeCert(index))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Remove",
                    text: "Remove"
                  })
                ], 8, _hoisted_14)
              ])
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newCertificationConfig.title) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newCertificationConfig.title]
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localMacroCat.subCategories, (subCat, subCatIndx) => {
              return (_openBlock(), _createElementBlock("td", {
                key: subCatIndx,
                class: "text-center"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.newCertificationConfig.subCategories[subCatIndx].value) = $event)
                }, null, 8, _hoisted_15), [
                  [_vModelText, _ctx.newCertificationConfig.subCategories[subCatIndx].value]
                ])
              ]))
            }), 128)),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-tertiary w-100 justify-content-center",
                disabled: !_ctx.newCertificationConfig.title,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCert()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Add",
                  text: "Add"
                })
              ], 8, _hoisted_16)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.localMacroCat.certifications.length == 0,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveConfig()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Save",
            text: "Save"
          })
        ], 8, _hoisted_18)
      ])
    ])
  ]))
}